module.exports = __webpack_public_path__ + "img/IMG_2523.2930a031.jpg";